.action {
  all: unset;
  color: var(--color-primary-crayola);
  font-size: 1.6rem;
  font-weight: 400;
  width: auto;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid var(--color-grayscale-trout);
}
